import {
  Button,
  Center,
  Flex,
  Heading,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  VStack,
} from '@chakra-ui/react';
import { HiCheck } from 'react-icons/hi';

const SecureDataEntryDevToolbar = ({ setIsInvalid }: { setIsInvalid: (a: boolean) => void }) => {
  return (
    <Center mt={20}>
      <VStack
        align="left"
        borderWidth={2}
        borderColor="grayBlueish"
        borderRadius="lg"
        mt="10px"
        p="10px"
        w="300px"
      >
        <Heading textAlign="center">Dev Tools</Heading>
        <Popover placement="top">
          {({ onClose }) => (
            <>
              <PopoverTrigger>
                <Button>Invalidate Link</Button>
              </PopoverTrigger>
              <PopoverContent p="10px" maxW="200px">
                <PopoverArrow />
                <Flex flexDir="column" alignItems="center" gap="5px">
                  Are you sure?
                  <Flex gap="5px">
                    <IconButton
                      icon={<HiCheck size="22.5px" />}
                      aria-label="confirm"
                      bg="green.500"
                      color="white"
                      _hover={{ bg: 'green.400', boxShadow: 'md' }}
                      onClick={() => {
                        onClose();
                        setIsInvalid(true);
                      }}
                    />
                  </Flex>
                </Flex>
              </PopoverContent>
            </>
          )}
        </Popover>
      </VStack>
    </Center>
  );
};

export default SecureDataEntryDevToolbar;
